import { type Theme, Typography } from '@mui/material';
import { useWebUserContext } from 'contexts';
import { makeStyles } from '@mui/styles';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    [theme.breakpoints.down('md')]: {
      float: 'right',
      padding: 10,

      '& .MuiTypography-h3': {
        fontSize: 18,
      },
      '& .MuiTypography-subtitle2': {
        fontSize: 20,
      },
    },
    [theme.breakpoints.up('md')]: {
      paddingTop: 40,
    },
  },
}), { name: 'HomeHeader' });

const HomeHeader = (): JSX.Element => {
  const { webUser } = useWebUserContext();
  const classes = useStyles();
  return (
    <div className={classes.header}>
      <Typography variant="h3">
        <FormattedMessage
          id="home.welcome"
          values={{ firstName: webUser.firstName, lastName: webUser.lastName }}
        />
      </Typography>
      <Typography variant="subtitle2">
        <FormattedMessage id="home.whatToDo" />
      </Typography>
    </div>
  );
}

export default HomeHeader;